import { makeStyles, Paper } from '@material-ui/core';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useAnswerContext } from '../../context';
import { Question } from './components';
import { questions } from './data';
const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '90%',
    width: 900,
    overflow: 'hidden',
    marginBottom: 90,
    boxShadow: '0px 2px 13px rgba(0,0,0,0.1);',
    transition: 'all 0.7s cubic-bezier(0.445, 0.050, 0.550, 0.950)',
    position: 'relative',
    borderRadius: 15,
    [theme.breakpoints.down('sm')]: {
      marginTop: 40,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: 140,
    },
  },
  line: {
    height: 10,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    transition: 'all 0.7s cubic-bezier(0.445, 0.050, 0.550, 0.950)',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
  },
  number: {
    margin: '20px 50px 35px',
    fontSize: 16,
  },
  content: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      margin: '40px 17px 6px',
    },
    [theme.breakpoints.up('sm')]: {
      margin: '64px 50px 6px',
    },
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: 10,
    width: '100%',
  },
}));

const getColor = (step: number, main: boolean = true) => {
  switch (step) {
    case 0: {
      return main ? '#4285F4' : 'rgb(210, 227, 252)';
    }
    case 1: {
      return main ? '#EA4335' : 'rgb(250, 210, 207)';
    }
    case 2: {
      return main ? '#FBBC04' : 'rgb(254, 239, 195)';
    }
    case 3: {
      return main ? '#34A853' : 'rgb(206, 234, 214)';
    }
    case 4: {
      return main ? '#EA4335' : 'rgb(250, 210, 207)';
    }
    case 5: {
      return main ? '#34A853' : 'rgb(206, 234, 214)';
    }
    case 6: {
      return main ? '#4285F4' : 'rgb(210, 227, 252)';
    }
    case 7: {
      return main ? '#FBBC04' : 'rgb(254, 239, 195)';
    }
  }
};

export const Survey = () => {
  const { setComplete, backToForm } = useAnswerContext();
  const { paper, line, number, content, footer } = useStyles();
  const divRef = useRef<HTMLDivElement>(null);
  const paperRef = useRef<HTMLDivElement>(null);
  const step = sessionStorage.getItem('step');
  const [activeStep, setActiveStep] = useState(step ? +step : 0);
  const [maxHeight, setMaxHeight] = useState(900);
  const [minHeight, setMinHeight] = useState(394);
  const [upd, increase] = useState(0);
  const history = useHistory<any>();
  const updateScroll = useCallback(() => increase((x) => x + 1), []);

  useEffect(() => {
    sessionStorage.setItem('step', activeStep.toString());
    if (history.location.state?.activeStep !== activeStep) {
      const search = history.location.search;
      history.push(
        history.location.pathname
          ? history.location.pathname + search
          : '/' + search,
        { activeStep },
      );
    }
  }, [activeStep, history]);

  useEffect(() => {
    const unlisten = history.listen((x: any) => {
      if (
        typeof x.state?.activeStep === 'number' &&
        activeStep !== x.state.activeStep
      ) {
        setActiveStep(x.state.activeStep);
      }
      if (x.state?.complete) {
        setComplete();
      }
      if (x.state?.form) {
        backToForm();
      }
    });
    return () => {
      unlisten();
    };
  }, [history, activeStep, setComplete, backToForm]);

  useLayoutEffect(() => {
    if (!divRef?.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((data) => {
      setMaxHeight(data[0].contentRect.height + 150);
      setMinHeight(data[0].contentRect.height + 150);
    });
    resizeObserver.observe(divRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useLayoutEffect(() => {
    if (!paperRef?.current) {
      return;
    }
    paperRef.current.scrollIntoView({});
  }, [activeStep, upd]);

  const data = questions[activeStep];

  const onNext = useCallback(() => {
    setActiveStep((x) => x + 1);
  }, []);
  const onBack = useCallback(() => {
    setActiveStep((x) => x - 1);
  }, []);

  return (
    <Paper ref={paperRef} className={paper} style={{ maxHeight, minHeight }}>
      <div ref={divRef}>
        <div className={content}>
          <Question
            onNext={onNext}
            onPrevious={onBack}
            isPreviousDisabled={activeStep === 0}
            updateScroll={updateScroll}
            {...data}
          />
        </div>
        <div className={footer}>
          <div className={number}>
            <strong>{activeStep + 1}</strong> of 8
          </div>
          <div
            className={line}
            style={{
              background: getColor(activeStep, false),
            }}
          ></div>
          <div
            className={line}
            style={{
              background: getColor(activeStep),
              width: `${12.5 * (activeStep + 1)}%`,
              borderBottomRightRadius: activeStep === 7 ? 4 : 0,
            }}
          ></div>
        </div>
      </div>
    </Paper>
  );
};
